import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaFaenas from './TablaFaenas';

const Faenas: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaFaenas />
    </Box>
  );
};

export default Faenas;
